import { FeatureEnum, FeatureType } from "../types/feature";
import { API_CONNECTED_OBJECT, API_FEATURE_ADD, API_FEATURE_EDIT, BASE_ADMIN, BASE_API } from "../constants/api";
import useAuth from "./useAuth";
import useRequest from "./useRequest";
import { UserRole } from "../types/user";
import { isSdiAdmin } from "../utils/roles";


type AddFeatureResponse = {
  feature: FeatureType;
}

export default function useSaveFeature() {
  const {user} = useAuth();
  const {
    error,
    response: saveResponse,
    request: saveFeatureRequest
  } = useRequest<AddFeatureResponse>();

  function saveFeature(toObjID: number, feature: FeatureEnum, data: unknown, objName: string ) {
    if (typeof data === "object") {
      const body = {
        feature: {
          type: feature,
          data,
          objName
        }
      }
      if (isSdiAdmin(user?.role) || user?.role === UserRole.site_admin) {
        saveFeatureRequest(BASE_ADMIN, `${API_CONNECTED_OBJECT}/${toObjID}/${API_FEATURE_EDIT}`, {method: 'PUT', secure: true}, body);
      } else {
        saveFeatureRequest(BASE_API, `${API_CONNECTED_OBJECT}/${toObjID}/${API_FEATURE_ADD}`, {method: 'POST', secure: true}, body);
      }
    }
  }

  return { saveFeature, saveResponse, error }
}